var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature5Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 6.2474C1.66797 5.0968 2.60071 4.16406 3.7513 4.16406H10.0013C11.1519 4.16406 12.0846 5.0968 12.0846 6.2474V14.5807C12.0846 15.7313 11.1519 16.6641 10.0013 16.6641H3.7513C2.60071 16.6641 1.66797 15.7313 1.66797 14.5807V6.2474Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7438 7.39904C14.3909 7.57548 14.168 7.93618 14.168 8.33073V12.4974C14.168 12.892 14.3909 13.2526 14.7438 13.4291L16.8271 14.4708C17.15 14.6322 17.5335 14.615 17.8406 14.4252C18.1477 14.2354 18.3346 13.9001 18.3346 13.5391V7.28906C18.3346 6.92805 18.1477 6.59277 17.8406 6.40297C17.5335 6.21317 17.15 6.19592 16.8271 6.35737L14.7438 7.39904Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5Icon);
export default __webpack_public_path__ + "static/media/feature-5-icon.5525e89f085e855dfdf0b07276a2f589.svg";
export { ForwardRef as ReactComponent };